import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../src/framework/layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';

/* Plugins */

import nuxt_plugin_plugin_7c9c2900 from 'nuxt_plugin_plugin_7c9c2900'; // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_0a19086e from 'nuxt_plugin_plugin_0a19086e'; // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_appplugin_23c8369c from 'nuxt_plugin_appplugin_23c8369c'; // Source: ../node_modules/.pnpm/@nuxt+bridge@3.3.1_@babel+core@7.23.7_@types+node@20.11.5_magicast@0.3.5_rollup@3.29.4_sass@1_6dpjp34baytvyj3kciztuucssi/node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_68341373 from 'nuxt_plugin_configplugin_68341373'; // Source: ../node_modules/.pnpm/@nuxt+bridge@3.3.1_@babel+core@7.23.7_@types+node@20.11.5_magicast@0.3.5_rollup@3.29.4_sass@1_6dpjp34baytvyj3kciztuucssi/node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_templatesplugin6c098f3c_510d5372 from 'nuxt_plugin_templatesplugin6c098f3c_510d5372'; // Source: ./templates.plugin.6c098f3c.js (mode: 'client')
import nuxt_plugin_googlegtag_3c1b3cc5 from 'nuxt_plugin_googlegtag_3c1b3cc5'; // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_webfontloader_7d44b2d4 from 'nuxt_plugin_webfontloader_7d44b2d4'; // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_distplugina498886e_1414f89e from 'nuxt_plugin_distplugina498886e_1414f89e'; // Source: ./dist.plugin.a498886e.mjs (mode: 'all')
import nuxt_plugin_workbox_bee3039c from 'nuxt_plugin_workbox_bee3039c'; // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_d0311976 from 'nuxt_plugin_metaplugin_d0311976'; // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_c6e1ce8e from 'nuxt_plugin_iconplugin_c6e1ce8e'; // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_capiplugin_7ce8c63d from 'nuxt_plugin_capiplugin_7ce8c63d'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_35d210e8 from 'nuxt_plugin_errorpluginserver_35d210e8'; // Source: ../node_modules/.pnpm/@nuxt+bridge@3.3.1_@babel+core@7.23.7_@types+node@20.11.5_magicast@0.3.5_rollup@3.29.4_sass@1_6dpjp34baytvyj3kciztuucssi/node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_mock_fd97ca88 from 'nuxt_plugin_mock_fd97ca88'; // Source: ../src/framework/plugins/mock (mode: 'client')
import nuxt_plugin_auth_ceca7a9a from 'nuxt_plugin_auth_ceca7a9a'; // Source: ../src/framework/plugins/di/auth.di (mode: 'client')
import nuxt_plugin_repository_70a98bd1 from 'nuxt_plugin_repository_70a98bd1'; // Source: ../src/framework/plugins/di/repository.di (mode: 'client')
import nuxt_plugin_localStorage_358a5a6a from 'nuxt_plugin_localStorage_358a5a6a'; // Source: ../src/framework/plugins/di/localStorage.di (mode: 'client')
import nuxt_plugin_logger_1e4557cb from 'nuxt_plugin_logger_1e4557cb'; // Source: ../src/framework/plugins/di/logger.di (mode: 'client')
import nuxt_plugin_dayjs_cdb113f4 from 'nuxt_plugin_dayjs_cdb113f4'; // Source: ../src/framework/plugins/di/dayjs.di (mode: 'client')
import nuxt_plugin_path_bd6a1152 from 'nuxt_plugin_path_bd6a1152'; // Source: ../src/framework/plugins/$path (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": true,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = null;
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Create Root instance
          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "titleTemplate": "reco",
              "title": "reco",
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
              }, {
                "name": "robots",
                "content": "noindex"
              }],
              "link": [{
                "rel": "stylesheet",
                "type": "text/css",
                "href": "https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css"
              }],
              "style": [],
              "script": [{
                "src": "https://www.googletagmanager.com/gtag/js?id=G-M46PZJFEY6",
                "async": true
              }]
            },
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App);
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 11;
          return setContext(app, {
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 11:
          // Inject runtime config as $config
          inject('config', config);

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_plugin_7c9c2900 === 'function')) {
            _context2.next = 16;
            break;
          }
          _context2.next = 16;
          return nuxt_plugin_plugin_7c9c2900(app.context, inject);
        case 16:
          if (!(typeof nuxt_plugin_plugin_0a19086e === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_plugin_0a19086e(app.context, inject);
        case 19:
          if (!(typeof nuxt_plugin_appplugin_23c8369c === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_appplugin_23c8369c(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_configplugin_68341373 === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_configplugin_68341373(app.context, inject);
        case 25:
          if (!(process.client && typeof nuxt_plugin_templatesplugin6c098f3c_510d5372 === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_templatesplugin6c098f3c_510d5372(app.context, inject);
        case 28:
          if (!(process.client && typeof nuxt_plugin_googlegtag_3c1b3cc5 === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_googlegtag_3c1b3cc5(app.context, inject);
        case 31:
          if (!(process.client && typeof nuxt_plugin_webfontloader_7d44b2d4 === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_webfontloader_7d44b2d4(app.context, inject);
        case 34:
          if (!(typeof nuxt_plugin_distplugina498886e_1414f89e === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_distplugina498886e_1414f89e(app.context, inject);
        case 37:
          if (!(process.client && typeof nuxt_plugin_workbox_bee3039c === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_workbox_bee3039c(app.context, inject);
        case 40:
          if (!(typeof nuxt_plugin_metaplugin_d0311976 === 'function')) {
            _context2.next = 43;
            break;
          }
          _context2.next = 43;
          return nuxt_plugin_metaplugin_d0311976(app.context, inject);
        case 43:
          if (!(typeof nuxt_plugin_iconplugin_c6e1ce8e === 'function')) {
            _context2.next = 46;
            break;
          }
          _context2.next = 46;
          return nuxt_plugin_iconplugin_c6e1ce8e(app.context, inject);
        case 46:
          if (!(typeof nuxt_plugin_capiplugin_7ce8c63d === 'function')) {
            _context2.next = 49;
            break;
          }
          _context2.next = 49;
          return nuxt_plugin_capiplugin_7ce8c63d(app.context, inject);
        case 49:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_35d210e8 === 'function')) {
            _context2.next = 52;
            break;
          }
          _context2.next = 52;
          return nuxt_plugin_errorpluginserver_35d210e8(app.context, inject);
        case 52:
          if (!(process.client && typeof nuxt_plugin_mock_fd97ca88 === 'function')) {
            _context2.next = 55;
            break;
          }
          _context2.next = 55;
          return nuxt_plugin_mock_fd97ca88(app.context, inject);
        case 55:
          if (!(process.client && typeof nuxt_plugin_auth_ceca7a9a === 'function')) {
            _context2.next = 58;
            break;
          }
          _context2.next = 58;
          return nuxt_plugin_auth_ceca7a9a(app.context, inject);
        case 58:
          if (!(process.client && typeof nuxt_plugin_repository_70a98bd1 === 'function')) {
            _context2.next = 61;
            break;
          }
          _context2.next = 61;
          return nuxt_plugin_repository_70a98bd1(app.context, inject);
        case 61:
          if (!(process.client && typeof nuxt_plugin_localStorage_358a5a6a === 'function')) {
            _context2.next = 64;
            break;
          }
          _context2.next = 64;
          return nuxt_plugin_localStorage_358a5a6a(app.context, inject);
        case 64:
          if (!(process.client && typeof nuxt_plugin_logger_1e4557cb === 'function')) {
            _context2.next = 67;
            break;
          }
          _context2.next = 67;
          return nuxt_plugin_logger_1e4557cb(app.context, inject);
        case 67:
          if (!(process.client && typeof nuxt_plugin_dayjs_cdb113f4 === 'function')) {
            _context2.next = 70;
            break;
          }
          _context2.next = 70;
          return nuxt_plugin_dayjs_cdb113f4(app.context, inject);
        case 70:
          if (!(process.client && typeof nuxt_plugin_path_bd6a1152 === 'function')) {
            _context2.next = 73;
            break;
          }
          _context2.next = 73;
          return nuxt_plugin_path_bd6a1152(app.context, inject);
        case 73:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 76;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 76:
          return _context2.abrupt("return", {
            app: app,
            router: router
          });
        case 77:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };